import React from 'react';
import { motion } from 'framer-motion';
import { ThreeBackground } from '../components/ThreeBackground';
import { Card3D } from '../components/Card3D';
import { PageTransition } from '../components/PageTransition';
const BRYAN_PHOTO = 'https://cdn.magicpatterns.com/uploads/jcswc8oANSg6paLTVfoQXv/IMG_0042.jpg';
export function AboutPage() {
  return <PageTransition data-id="element-43">
      {/* Page Header */}
      <section className="relative bg-navy-900 pt-32 pb-20 overflow-hidden bg-glow" data-id="element-44">
        <ThreeBackground data-id="element-45" />
        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12" data-id="element-46">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-47">
            <span className="text-gold font-bold tracking-widest text-sm uppercase mb-2 block" data-id="element-48">
              About
            </span>
            <h1 className="text-4xl md:text-5xl font-bold text-white" data-id="element-49">
              Executive Profile
            </h1>
          </motion.div>
        </div>
      </section>

      {/* Profile Section */}
      <section className="bg-light py-20" data-id="element-50">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-51">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-16 items-start" data-id="element-52">
            {/* Photo */}
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.7
          }} className="lg:col-span-2" style={{
            perspective: 1000
          }} data-id="element-53">
              <div className="relative" data-id="element-54">
                <div className="absolute -inset-3 bg-gradient-to-br from-gold/20 to-transparent rounded-lg" data-id="element-55" />
                <img src={BRYAN_PHOTO} alt="Bryan E. Nicholson, Director of Field Operations" className="relative w-full max-w-md mx-auto rounded-lg shadow-2xl border-2 border-gold/30 object-cover aspect-[4/5]" data-id="element-56" />
              </div>
              <div className="mt-6 text-center lg:text-left" data-id="element-57">
                <h2 className="text-2xl font-bold text-ink" data-id="element-58">
                  Bryan E. Nicholson
                </h2>
                <p className="text-gold font-medium mt-1" data-id="element-59">
                  Director, Field Operations – Gas Processing
                </p>
                <p className="text-ink-muted text-sm mt-1" data-id="element-60">
                  Texas, United States
                </p>
              </div>
            </motion.div>

            {/* Summary */}
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.7,
            delay: 0.2
          }} className="lg:col-span-3 space-y-6 text-lg text-ink-muted leading-relaxed" data-id="element-61">
              <p data-id="element-62">
                <strong className="text-ink font-semibold" data-id="element-63">
                  Bryan Nicholson
                </strong>{' '}
                is a seasoned operations executive with more than 20 years of
                leadership experience in cryogenic gas processing,
                fractionation, and midstream operations. He has successfully
                commissioned and managed high-capacity gas processing plants up
                to 200 MMSCFD and overseen complex multi-site operations.
              </p>
              <p data-id="element-64">
                He is recognized as a trusted advisor to executive leadership
                and boards, providing strategic operational guidance, risk
                management, and performance optimization. Bryan has extensive
                expertise in plant commissioning, process optimization, safety
                leadership, and large-scale operational management within the
                energy sector.
              </p>
              <p data-id="element-65">
                His leadership focuses on operational excellence, continuous
                improvement, regulatory compliance, and building high-performing
                teams that drive reliability, efficiency, and long-term
                enterprise value.
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Key Metrics */}
      <section className="bg-white py-16" data-id="element-66">
        <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-67">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-68">
            <Card3D data-id="element-69">
              <div className="bg-light border border-gray-100 p-8 text-center" data-id="element-70">
                <span className="text-4xl md:text-5xl font-bold text-gold block mb-2" data-id="element-71">
                  20+
                </span>
                <span className="text-ink-muted text-sm font-medium" data-id="element-72">
                  Years Experience
                </span>
              </div>
            </Card3D>
            <Card3D data-id="element-73">
              <div className="bg-light border border-gray-100 p-8 text-center" data-id="element-74">
                <span className="text-4xl md:text-5xl font-bold text-gold block mb-2" data-id="element-75">
                  720
                </span>
                <span className="text-ink-muted text-sm font-medium" data-id="element-76">
                  MMSCFD Capacity
                </span>
              </div>
            </Card3D>
            <Card3D data-id="element-77">
              <div className="bg-light border border-gray-100 p-8 text-center" data-id="element-78">
                <span className="text-4xl md:text-5xl font-bold text-gold block mb-2" data-id="element-79">
                  5
                </span>
                <span className="text-ink-muted text-sm font-medium" data-id="element-80">
                  Processing Trains
                </span>
              </div>
            </Card3D>
            <Card3D data-id="element-81">
              <div className="bg-light border border-gray-100 p-8 text-center" data-id="element-82">
                <span className="text-4xl md:text-5xl font-bold text-gold block mb-2" data-id="element-83">
                  200
                </span>
                <span className="text-ink-muted text-sm font-medium" data-id="element-84">
                  MMSCFD Largest Plant
                </span>
              </div>
            </Card3D>
          </div>
        </div>
      </section>

      {/* Leadership Philosophy */}
      <section className="py-28 bg-navy-900 relative overflow-hidden bg-glow" data-id="element-85">
        <div className="absolute inset-0 bg-gradient-to-br from-navy-900 via-navy-800 to-navy-900 opacity-50" data-id="element-86" />
        <div className="relative z-10 max-w-5xl mx-auto px-6 md:px-12 text-center" data-id="element-87">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="text-gold/20 font-serif text-[10rem] leading-none absolute -top-16 left-1/2 -translate-x-1/2 select-none pointer-events-none" aria-hidden="true" data-id="element-88">
            &ldquo;
          </motion.div>

          <motion.blockquote initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative z-10" data-id="element-89">
            <p className="text-2xl md:text-3xl lg:text-4xl font-medium text-white leading-relaxed mb-10 italic" data-id="element-90">
              Operational excellence is not a destination — it is a discipline.
              My leadership is built on building high-performing teams, driving
              continuous improvement, and delivering measurable results that
              create long-term enterprise value.
            </p>
            <footer className="text-gold font-bold tracking-widest uppercase text-lg" data-id="element-91">
              — Bryan E. Nicholson
            </footer>
          </motion.blockquote>
        </div>
      </section>
    </PageTransition>;
}